<template>
  <div class="document-container">
    <div class="document" v-if="assist.tool.isNotEmpty(contractUrl) || assist.tool.isNotEmpty(certificateUrl)">
      <div class="document-type">
        <a class="fad fa-file-contract" :href="contractUrl" target="_blank"></a>
      </div>
      <span class="document-time">{{ signedAt }}</span>
    </div>
    <div class="document" v-if="assist.tool.isNotEmpty(contractUrl) || assist.tool.isNotEmpty(certificateUrl)">
      <div class="document-type">
        <a :href="certificateUrl" target="_blank"><i class="fad fa-file-certificate d-inline-block"></i></a>
      </div>
      <span class="document-time">{{ signedAt }}</span>
    </div>
  </div>
</template>

<script>
import { DataType, Tool } from '@/util/index'
const tool = new Tool()

export default {
  name: 'application-detail-document-folder',
  components: {},
  props: {
    loan: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      contractUrl: '',
      certificateUrl: '',
      signedAt: '-- ::',
      assist: {
        tool: new Tool()
      },
      documentFolderHistoryDisplay: false
    }
  },
  computed: {
    loanId () {
      return this.loan.id
    }
  },
  watch: {
    loanId () {
      this.displayDocumentFolder()
    }
  },
  destroyed () {
    this.$eventBus.$off('loanSignDataDisplay')
  },
  mounted () {
    this.$eventBus.$on('loanSignDataDisplay', target => {
      this.displayDocumentFolder()
    })
    this.$eventBus.$on('updateSignStatus', target => {
      const signStatus = target.value
      if (signStatus !== DataType.SignStatusEnum.SIGNED.value) {
        this.contractUrl = ''
        this.certificateUrl = ''
      }
    })
  },
  methods: {
    displayDocumentFolder () {
      const loanData = this.store.getters.getLoan
      if (loanData.signStatus === DataType.SignStatusEnum.SIGNED.value) {
        this.contractUrl = loanData.contractUrl
        this.certificateUrl = loanData.certificateUrl
        const signedAt = loanData.signedAt
        if (tool.isNotEmpty(signedAt)) {
          this.signedAt = tool.formatDateTime(signedAt)
        }
      }
    }
  }
}
</script>

<style scoped>
.document-container {
  padding: 20px 0;
}

.document {
  width: 120px;
  text-align: center;
  color: #002B7F;
  float: right;
}

.document-type {
  margin-bottom: 5px;
  font-size: 100px;
  line-height: 100px;
}
.document-time {
  line-height: 20px;
}
  a {
    color: #002B7F;
  }
  .document-container .document-folder-history {
    left: 100%
  }
</style>
